import React, { useState, useEffect } from "react";
import { Grid } from "@material-ui/core";
import config from "../../config";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';

// styles
import useStyles from "./styles";

// components
import DashboardCard from "../../components/Widget/DashboardCard";
import MembershipTable from "./components/Memberships/MembershipTable";
import Modal from "../modals/Modal";
import MostSold from "./components/MostSold";
import LogsTable from "./components/Memberships/LogsTable";
import SnackbarMessage from "../modals/SnackbarMessage";

export default function Dashboard(props) {
  var classes = useStyles();

  const [baseUrl, setBaseUrl] = useState(config.config[0].baseUrl);
  const [expiredMemberships, setExpiredMemberships] = useState([]);
  const [nextMembershipToExpire, setNextMembershipToExpire] = useState([]);
  const [actionsDb, setActionsDb] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [accumulatedItems, setAccumulatedItems] = useState(0);
  const [itemsOnPage, setItemsOnPage] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [nextCurrentPage, setNextCurrentPage] = useState(1);
  const [nextTotalPages, setNextTotalPages] = useState(1);
  const [nextAccumulatedItems, setNextAccumulatedItems] = useState(0);
  const [nextItemsOnPage, setNextItemsOnPage] = useState(0);
  const [nextTotalItems, setNextTotalItems] = useState(0);
  const [actionCurrentPage, setActionCurrentPage] = useState(1);
  const [actionTotalPages, setActionTotalPages] = useState(1);
  const [actionAccumulatedItems, setActionAccumulatedItems] = useState(0);
  const [actionItemsOnPage, setActionItemsOnPage] = useState(0);
  // const [actionTotalItems, setActionTotalItems] = useState(0);
  const [showModal, setShowModal] = useState(false);
  const [newMemberships, setNewMemberships] = useState(0);
  const [entryAreas, seEntryAreas] = useState({ box: 0, pesas: 0 });
  const [chartInfo, setChartInfo] = useState(null);

  const [showSnackbar, setShowSnackbar] = useState(false);
  const [messageSnackbar, setMessageSnackbar] = useState(false);
  const [errorSnackbar, setErrorSnackbar] = useState(false);

  const handleToClose = (event, reason) => {
    if ("clickaway" == reason) return;
    setShowSnackbar(false);
  };

  const closeModalLogin = e => {
    setShowModal(false);
  }

  const onNextPage = e => {
    if (currentPage < totalPages) {
      fetch(baseUrl + "partners/membershipExpired/" + currentPage,
        {
          headers: {
            'Accept': 'application/json', 'Content-Type': 'application/json',
            'Authorization': localStorage.getItem("token")
          },
        }).then(response => response.json())
        .then(data => {
          const newData = data.content;

          if (newData) {
            setExpiredMemberships(newData);
            setTotalPages(data.totalPages);
            setCurrentPage(data.number + 1);
            setAccumulatedItems(accumulatedItems + data.numberOfElements);
            setItemsOnPage(data.numberOfElements);
            setTotalItems(data.totalElements);
          } else {
            setMessageSnackbar("Error al consultar socios vencidos");
            setErrorSnackbar(true);
            setShowSnackbar(true);
          }
        })
        .catch(error => null);
    }
  }

  const onPreviousPage = e => {
    if (currentPage > 1) {
      fetch(baseUrl + "partners/membershipExpired/" + (currentPage - 2),
        {
          headers: {
            'Accept': 'application/json', 'Content-Type': 'application/json',
            'Authorization': localStorage.getItem("token")
          },
        }).then(response => response.json())
        .then(data => {
          const newData = data.content;

          if (newData != null) {
            setExpiredMemberships(newData);
            setTotalPages(data.totalPages);
            setCurrentPage(data.number + 1);
            setAccumulatedItems(accumulatedItems - itemsOnPage);
            setItemsOnPage(data.numberOfElements);
            setTotalItems(data.totalElements);
          } else {
            setMessageSnackbar("Error al consultar socios vencidos");
            setErrorSnackbar(true);
            setShowSnackbar(true);
          }
        })
        .catch(error => null);
    }
  }

  const onNextPageNextMembership = e => {
    if (nextCurrentPage < nextTotalPages) {
      fetch(baseUrl + "partners/nextMembershipToExpired/" + nextCurrentPage,
        {
          headers: {
            'Accept': 'application/json', 'Content-Type': 'application/json',
            'Authorization': localStorage.getItem("token")
          },
        }).then(response => response.json())
        .then(data => {
          const newData = data.content;

          if (newData != null) {
            setNextMembershipToExpire(newData);
            setNextTotalPages(data.totalPages);
            setNextCurrentPage(data.number + 1);
            setNextAccumulatedItems(nextAccumulatedItems + data.numberOfElements);
            setNextItemsOnPage(data.numberOfElements);
            setNextTotalItems(data.totalElements);
          } else {
            setMessageSnackbar("Error al consultar próximos socios a vencer");
            setErrorSnackbar(true);
            setShowSnackbar(true);
          }
        })
        .catch(error => null);
    }
  }

  const onPreviousPageNextMembership = e => {
    if (nextCurrentPage > 1) {
      fetch(baseUrl + "partners/nextMembershipToExpired/" + (nextCurrentPage - 2),
        {
          headers: {
            'Accept': 'application/json', 'Content-Type': 'application/json',
            'Authorization': localStorage.getItem("token")
          },
        }).then(response => response.json())
        .then(data => {
          const newData = data.content;

          if (newData != null) {
            setNextMembershipToExpire(newData);
            setNextTotalPages(data.totalPages);
            setNextCurrentPage(data.number + 1);
            setNextAccumulatedItems(nextAccumulatedItems - nextItemsOnPage);
            setNextItemsOnPage(data.numberOfElements);
            setNextTotalItems(data.totalElements);
          } else {
            setMessageSnackbar("Error al consultar próximos socios a vencer");
            setErrorSnackbar(true);
            setShowSnackbar(true);
          }
        })
        .catch(error => null);
    }
  }

  const onNextPageActionDate = e => {
    if (actionCurrentPage < actionTotalPages) {
      const today = new Date();
      var day = "";
      var newDateInputFormat = "";

      if (today.getDate() < 10) {
        day = '0' + today.getDate();
      } else {
        day = today.getDate();
      }

      if ((today.getMonth() + 1) < 10) {
        newDateInputFormat = day + '/0' + (today.getMonth() + 1) + '/' + today.getFullYear();
      } else {
        newDateInputFormat = day + '/' + (today.getMonth() + 1) + '/' + today.getFullYear();
      }

      const body = {
        dateOne: newDateInputFormat
      };

      fetch(baseUrl + "getActions/" + actionCurrentPage,
        {
          method: 'POST',
          headers: {
            'Accept': 'application/json', 'Content-Type': 'application/json',
            'Authorization': localStorage.getItem("token")
          },
          body: JSON.stringify(body)
        }).then(response => response.json())
        .then(data => {
          const newData = data.content;

          if (newData != null) {
            setActionsDb(newData);
            setActionTotalPages(data.totalPages);
            setActionCurrentPage(data.number + 1);
            setActionAccumulatedItems(actionAccumulatedItems + data.numberOfElements);
            setActionItemsOnPage(data.numberOfElements);
            // setActionTotalItems(data.totalElements);
          } else {
            setMessageSnackbar("Error al consultar próximas citas al sauna");
            setErrorSnackbar(true);
            setShowSnackbar(true);
          }
        })
        .catch(error => null);
    }
  }

  const onPreviousPageAcionDate = e => {
    if (actionCurrentPage > 1) {
      const today = new Date();
      var day = "";
      var newDateInputFormat = "";

      if (today.getDate() < 10) {
        day = '0' + today.getDate();
      } else {
        day = today.getDate();
      }

      if ((today.getMonth() + 1) < 10) {
        newDateInputFormat = day + '/0' + (today.getMonth() + 1) + '/' + today.getFullYear();
      } else {
        newDateInputFormat = day + '/' + (today.getMonth() + 1) + '/' + today.getFullYear();
      }

      const body = {
        dateOne: newDateInputFormat
      };

      fetch(baseUrl + "getActions/" + (actionCurrentPage - 2),
        {
          method: 'POST',
          headers: {
            'Accept': 'application/json', 'Content-Type': 'application/json',
            'Authorization': localStorage.getItem("token")
          },
          body: JSON.stringify(body)
        }).then(response => response.json())
        .then(data => {
          const newData = data.content;

          if (newData != null) {
            setActionsDb(newData);
            setActionTotalPages(data.totalPages);
            setActionCurrentPage(data.number + 1);
            setActionAccumulatedItems(actionAccumulatedItems - actionItemsOnPage);
            setActionItemsOnPage(data.numberOfElements);
            // setActionTotalItems(data.totalElements);
          } else {
            setMessageSnackbar("Error al consultar acciones");
            setErrorSnackbar(true);
            setShowSnackbar(true);
          }
        })
        .catch(error => null);
    }
  }

  const fetchExpiredMemberships = async () => {
    await fetch(baseUrl + "partners/membershipExpired/0",
      {
        headers: {
          'Accept': 'application/json', 'Content-Type': 'application/json',
          'Authorization': localStorage.getItem("token")
        },
      }).then(response => response.json())
      .then(data => {
        const newData = data.content;

        if (newData != null) {
          setExpiredMemberships(newData);
          setTotalPages(data.totalPages);
          setAccumulatedItems(data.numberOfElements);
          setItemsOnPage(data.numberOfElements);
          setTotalItems(data.totalElements);
        } else {
          if (newData.message == "Access is denied" || data.error == "Forbidden") {
            setShowModal(true);
          }
        }
      })
      .catch(error => {
        setMessageSnackbar("Error al consultar socios vencidos");
        setErrorSnackbar(true);
        setShowSnackbar(true);
      });

    fetchNextMembershipsToExpired();
  }

  const fetchNextMembershipsToExpired = async () => {
    await fetch(baseUrl + "partners/nextMembershipToExpired/0",
      {
        headers: {
          'Accept': 'application/json', 'Content-Type': 'application/json',
          'Authorization': localStorage.getItem("token")
        },
      }).then(response => response.json())
      .then(data => {
        const newData = data.content;

        if (newData != null) {
          setNextMembershipToExpire(newData);
          setNextTotalPages(data.totalPages);
          setNextAccumulatedItems(data.numberOfElements);
          setNextItemsOnPage(data.numberOfElements);
          setNextTotalItems(data.totalElements);
        } else {
          if (newData.message == "Access is denied" || data.error == "Forbidden") {
            setShowModal(true);
          }
        }
      })
      .catch(error => {
        setMessageSnackbar("Error al consultar próximos socios a vencer");
        setErrorSnackbar(true);
        setShowSnackbar(true);
      });

    fetchAcionDate();
  }

  const fetchAcionDate = async () => {
    const today = new Date();
    var day = "";
    var newDateInputFormat = "";

    if (today.getDate() < 10) {
      day = '0' + today.getDate();
    } else {
      day = today.getDate();
    }

    if ((today.getMonth() + 1) < 10) {
      newDateInputFormat = day + '/0' + (today.getMonth() + 1) + '/' + today.getFullYear();
    } else {
      newDateInputFormat = day + '/' + (today.getMonth() + 1) + '/' + today.getFullYear();
    }

    const body = {
      dateOne: newDateInputFormat
    };

    await fetch(baseUrl + "getActions/0",
      {
        method: 'POST',
        headers: {
          'Accept': 'application/json', 'Content-Type': 'application/json',
          'Authorization': localStorage.getItem("token")
        },
        body: JSON.stringify(body)
      }).then(response => response.json())
      .then(data => {
        const newData = data.content;

        if (newData != null) {
          setActionsDb(newData);
          setActionTotalPages(data.totalPages);
          setActionAccumulatedItems(data.numberOfElements);
          setActionItemsOnPage(data.numberOfElements);
          // setActionTotalItems(data.totalElements);
        } else {
          if (newData.message == "Access is denied" || data.error == "Forbidden") {
            setShowModal(true);
          }
        }
      })
      .catch(error => {
        setMessageSnackbar("Error al consultar acciones");
        setErrorSnackbar(true);
        setShowSnackbar(true);
      });

    fetchNewMemberships(newDateInputFormat);
  }

  const fetchNewMemberships = async (date) => {
    const body = {
      dateOne: date
    };

    await fetch(baseUrl + "newPartners",
      {
        method: 'POST',
        headers: {
          'Accept': 'application/json', 'Content-Type': 'application/json',
          'Authorization': localStorage.getItem("token")
        },
        body: JSON.stringify(body)
      }).then(response => response.json())
      .then(data => {
        if (data.message == "Ok") {
          setNewMemberships(data.content)
        } else {
          if (data.message == "Access is denied") {
            setShowModal(true);
          }
        }
      })
      .catch(error => {
        setMessageSnackbar("Error al consultar nuevos socios");
        setErrorSnackbar(true);
        setShowSnackbar(true);
      });

    fetchEntryAreas(date)
  }

  const fetchEntryAreas = async (date) => {
    const body = {
      dateOne: date
    };

    await fetch(baseUrl + "partnerAccessCount",
      {
        method: 'POST',
        headers: {
          'Accept': 'application/json', 'Content-Type': 'application/json',
          'Authorization': localStorage.getItem("token")
        },
        body: JSON.stringify(body)
      }).then(response => response.json())
      .then(data => {
        if (data.message == "Ok") {
          seEntryAreas({ box: data.gymCount, pesas: data.pesasCount })
        } else {
          if (data.message == "Access is denied") {
            setShowModal(true);
          }
        }
      })
      .catch(error => {
        setMessageSnackbar("Error al consultar entradas");
        setErrorSnackbar(true);
        setShowSnackbar(true);
      });

    fetchCharts(date);
  }

  const fetchCharts = async (date) => {
    const body = {
      dateOne: date
    };

    fetch(baseUrl + "chart",
      {
        method: 'POST',
        headers: {
          'Accept': 'application/json', 'Content-Type': 'application/json',
          'Authorization': localStorage.getItem("token")
        },
        body: JSON.stringify(body)
      }).then(response => response.json())
      .then(data => {
        if (data.message == "Ok") {
          var listChart = [];

          for (var i = 0; i < data.content.labels.length; i++) {
            listChart.push({
              name: data.content.labels[i],
              Ingresos: data.content.entryValues[i],
              Egresos: data.content.egressValues[i],
            });
          }

          setChartInfo(listChart);
        } else {
          if (data.message == "Access is denied") {
            setShowModal(true);
          }
        }
      })
      .catch(error => {
        setMessageSnackbar("Error al consultar gréficas");
        setErrorSnackbar(true);
        setShowSnackbar(true);
      });
  }

  useEffect(() => {
    fetchExpiredMemberships();
  }, []);

  return (
    <>
      <div>
        <SnackbarMessage
          showSnackbar={showSnackbar}
          messageSnackbar={messageSnackbar}
          handleToClose={handleToClose}
          isError={errorSnackbar}
        />

        {showModal ? (
          <Modal
            isOpen={showModal}
            closeModal={closeModalLogin}
          />
        ) : (
          <></>
        )}

        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} md={12}>
            <DashboardCard
              title="Acciones"
              upperTitle
              bodyClass={classes.fullHeightBody}
              className={classes.card}
            >
              <div className={classes.visitsNumberContainer}>
                <Grid container item alignItems={"center"}>
                  <Grid item xs={12}>
                    {actionsDb.length > 0 ? (
                      <div className={classes.loginLoader} >
                        <LogsTable
                          data={actionsDb}
                          currentPage={actionCurrentPage}
                          totalPages={actionTotalPages}
                          onPreviousPage={onPreviousPageAcionDate}
                          onNextPage={onNextPageActionDate}
                        />
                      </div>
                    ) : (
                      <p style={{ fontSize: "36px", color: "#FFFFFF", justify: 'center', alignItems: 'center', textAlign: "center" }}>Sin registros</p>
                    )}
                  </Grid>
                </Grid>
              </div>
            </DashboardCard>
          </Grid>
        </Grid>

        <br />
        <Grid container spacing={4}>
          <Grid item xs={12} sm={6} md={4}>
            <MostSold
              title={"Nuevas membresías"}
              productName={newMemberships}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <MostSold
              title={"Entradas a Box"}
              productName={entryAreas.box}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <MostSold
              title={"Entradas a Pesas"}
              productName={entryAreas.pesas}
            />
          </Grid>
        </Grid>

        <Grid container spacing={3} style={{ marginTop: "8px" }}>
          <Grid item xs={12} sm={12} md={12}>
            <DashboardCard
              title="Membresías vencidas"
              upperTitle
              bodyClass={classes.fullHeightBody}
              className={classes.card}
            >
              <div className={classes.visitsNumberContainer}>
                <Grid container item alignItems={"center"}>
                  <Grid item xs={12}>
                    {expiredMemberships.length > 0 ? (
                      <div className={classes.loginLoader} >
                        <MembershipTable
                          data={expiredMemberships}
                          isExpired={true}
                          currentPage={currentPage}
                          totalPages={totalPages}
                          onPreviousPage={onPreviousPage}
                          onNextPage={onNextPage}
                          accumulatedItems={accumulatedItems}
                          totalItems={totalItems}
                        />
                      </div>
                    ) : (
                      <p style={{ fontSize: "36px", color: "#FFFFFF", justify: 'center', alignItems: 'center', textAlign: "center" }}>Socios al corriente</p>
                    )}
                  </Grid>
                </Grid>
              </div>
            </DashboardCard>
          </Grid>
          <Grid item xs={12} sm={12} md={12}>
            <DashboardCard
              title="Membresías próximas a vencer"
              upperTitle
              className={classes.card}
              bodyClass={classes.fullHeightBody}
            >
              <div className={classes.visitsNumberContainer}>
                <Grid container item alignItems={"center"}>
                  <Grid item xs={12}>
                    {nextMembershipToExpire.length > 0 ? (
                      <div className={classes.loginLoader} >
                        <MembershipTable
                          data={nextMembershipToExpire}
                          isExpired={false}
                          currentPage={nextCurrentPage}
                          totalPages={nextTotalPages}
                          onPreviousPage={onPreviousPageNextMembership}
                          onNextPage={onNextPageNextMembership}
                          accumulatedItems={nextAccumulatedItems}
                          totalItems={nextTotalItems}
                        />
                      </div>
                    ) : (
                      <p style={{ fontSize: "36px", color: "#FFFFFF", justify: 'center', alignItems: 'center', textAlign: "center" }}>Sin socios próximos</p>
                    )}
                  </Grid>
                </Grid>
              </div>
            </DashboardCard>
          </Grid>
          <Grid item xs={12} sm={12} md={12} style={{ marginBottom: "100px" }}>
            <DashboardCard
              title=""
              upperTitle
              className={classes.card}
              bodyClass={classes.fullHeightBody}
            >
              <div className={classes.visitsNumberContainer}>
                <BarChart
                  width={1000}
                  height={300}
                  data={chartInfo}
                  margin={{
                    top: 5,
                    right: 30,
                    left: 20,
                    bottom: 5,
                  }}
                >
                  <CartesianGrid strokeDasharray='3 3' />
                  <XAxis dataKey='name' />
                  <YAxis />
                  <Tooltip />
                  <Legend />
                  <Bar dataKey='Ingresos' fill='#3CD4A0' />
                  <Bar dataKey='Egresos' fill='#7E1E1E' />
                </BarChart>
              </div>
            </DashboardCard>
          </Grid>
        </Grid>
      </div>
    </>
  );
}